import { useTheme } from '@mui/material';
import { FC } from 'react';
import { ReactComponent as ConnectivityIssueSVG } from '../../assets/icons/connectivity-issue.svg';
import CustomTooltip from '../../common/components/CustomTooltip';

const TokenInvalid: FC<React.PropsWithChildren<TokenInvalidProps>> = ({
  noReposFound,
}) => {
  const theme = useTheme();
  return (
    <CustomTooltip
      title={
        noReposFound
          ? 'No repositories were found with the provided token'
          : 'Invalid token'
      }>
      <ConnectivityIssueSVG
        color='error'
        width='1.2rem'
        style={{ color: theme.palette.error.main }}
      />
    </CustomTooltip>
  );
};

interface TokenInvalidProps {
  noReposFound?: boolean;
}

export default TokenInvalid;
